import React from 'react'

export default function Accesscontrol() {
  return (
    <div>
      Accesscontrol
    </div>
  )
}
